import _Vue from 'vue';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

export default {
  install(Vue: typeof _Vue, options: { token: string }) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$stytch = new StytchB2BUIClient(options.token);
  }
};
